import { Component } from '@angular/core';

/**
 * Generated class for the SendFaxDialogComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'send-fax-dialog',
  templateUrl: 'send-fax-dialog.html'
})
export class SendFaxDialogComponent {

  text: string;

  constructor() {
    console.log('Hello SendFaxDialogComponent Component');
    this.text = 'Hello World';
  }

}



// WEBPACK FOOTER //
// ./src/components/send-fax-dialog/send-fax-dialog.ts